<template>
  <div class="l-wrapper">
    <header class="l-header">
      <div class="l-header-in">
        <div class="l-header-wrap">
          <p class="l-header_logo" v-if="visibleLogo===true"><img src="@/assets/images/logo_wendys.png" :alt="companyName.wfk" class="wendys"><img src="@/assets/images/logo_firstkitchen.png" :alt="companyName.fk" class="fk"></p>
          <h1 class="page-title" v-if="visibleLogo===false">{{pageTitle}}</h1>
          <div class="btn-spMenu js-btn-spMenu" @click="toggleMenu" :class="!menu || 'active'" v-if='errorLayout!==true'>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <nav class="l-header_nav" :class="!menu || 'active'" v-if='errorLayout!==true'>
            <ul>
              <li><a href="#" @click.prevent="transition($event, 'Cart')">{{$t('General.Cart')}}</a></li>
              <li><a href="#" @click.prevent="transition($event, getHomepage())">{{$t('General.Top')}}</a></li>
              <li v-if="DPayEnabled"><a href="#" @click.prevent="transition($event, 'OrderHistory')">{{$t('General.OrderHistory')}}</a></li>
              <li><a :href="getPrivacyPolicyUrl()" target="_blank">{{$t('General.PrivacyPolicy')}}</a></li>
              <li v-if="DPayEnabled"><a href="#" @click.prevent="transition($event, 'Tokusho')">{{$t('General.Tokusho')}}</a></li>
              <li v-if="DPayEnabled"><a href="#" @click.prevent="transition($event, 'UserPolicy')">{{$t('UserPolicy.Head')}}</a></li>
              <Datepicker v-if='Datepickerparam.display' id="open_at" :language="Datepickerparam.ja" :format="Datepickerparam.DatepickerFormat"
               placeholder="表示日指定" :clear-button=true style="width: 100%;" @input="input_open_at"
               :value=Datepickerparam.initialDate :highlighted=Datepickerparam.highlighted @login="checkDatepicker"></Datepicker>
            </ul>
          </nav>
        </div>
        <p class="btn-cart" v-if='errorLayout!==true'><a href="#" @click.prevent="gotoCart">{{$t('General.Cart')}}<span class="badge-cart" v-if="cartItemCount > 0"><i class="num">{{cartItemCount}}</i></span></a></p>
      </div>
    </header>
    <div id="common-modal" class="modal-box" v-bind:class="{enable: dialogParam.pop}">
      <div class="modal-box_bg"></div>
      <div class="campaign-modal-content">

        <div class="campaign-item">
          <h3 v-html="dialogParam.text"></h3>
        </div>
        <ul class="campaign-btn campaign-btn2" v-if='dialogParam.buttons==2'>
          <li><span @click='confirmAlert()'>{{dialogParam.textYes ? dialogParam.textYes : dialogParam._textYes}}</span></li>
          <li><span class="js-modal_close" @click='rejectAlert()'>{{dialogParam.textNo ? dialogParam.textNo : dialogParam._textNo}}</span></li>
        </ul>
        <ul class="campaign-btn campaign-btn1" v-if='dialogParam.buttons==1'>
          <li><span @click='confirmAlert()'>{{dialogParam.textOk ? dialogParam.textOk : dialogParam._textOk}}</span></li>
        </ul>
        <p class="modal-close js-modal_close" @click='rejectAlert()'>閉じる</p>
      </div>
    </div>

    <router-view/>
  </div>
</template>

<script>
import Moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import {ja} from 'vuejs-datepicker/dist/locale'
import CommonMixin from '@/mixins/CommonMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
import {get, replace, toNumber, clone, isObject, isString} from 'lodash'
export default {
  name: 'App',
  mixins: [ CommonMixin, DisplayErrorMixin ],
  data () {
    return {
      pageTitle: null,
      cartItemCount: 0,
      menu: false, // ハンバーガーメニューの表示制御
      fkmoTimer: null, // タイマー制御
      updated: false, // cart.item_listの子要素に更新があればフラグを立てる
      visibleLogo: true, // 企業ロゴの表示フラグ
      commonDialogStatus: false,
      errorLayout: false, // エラーページ用表示レイアウト
      companyName: {
        fk: null,
        wfk: null
      },
      dialogParam: {
        pop: false,
        text: '',
        buttons: 1,
        textYes: '',
        textNo: '',
        textOk: '',
        _textYes: '',
        _textNo: '',
        _textOk: '',
        resolve: null
      },
      appTime: {
        difference: 0, // ミリ秒
        checkTimer: null
      },
      DPayEnabled: false,
      Datepickerparam: {
        DatepickerFormat: 'yyyy-MM-dd',
        highlighted: {
          dates: []
        },
        initialDate: null,
        display: false,
        ja: ja
      }
    }
  },
  components: {
    Datepicker
  },
  computed: {
    getCart () {
      return this.$store.getters.cart
    },
    getServerTime () {
      return this.$store.getters.serverTime
    },
    getSelectStore () {
      return this.$store.getters.selectStore
    },
    getDisabledButton () {
      return this.$store.getters.disabledButton
    },
    getAuthority () {
      return this.$store.getters.userAuthority
    }
  },
  watch: {
    '$route' (to, from) {
      // ページタイトル制御（ルーティング操作時）
      this.pageTitle = this.getPageTitle(this.$router.history.current.name)
      // バッジ表示制御
      this.cartItemCount = this.calcQuantity(this.getCart.item_list, this.getCart.accounting_coupon)
      // title要素を書き換える
      document.title = this.getTitleElementString(this.pageTitle)
      // 企業ロゴの表示フラグを変更する
      if (this.$router.history.current.name === this.getHomepage()) {
        this.visibleLogo = true
      } else {
        this.visibleLogo = false
      }
      if (this.$router.currentRoute.name === 'ErrorPage') {
        this.visibleLogo = true
        this.errorLayout = true
      } else {
        this.errorLayout = false
      }
      if (this.$router.currentRoute.name === 'UserPolicy' &&
          this.DPayEnabled &&
          (!this.$store.getters.userPolicyAgreed)) {
        this.visibleLogo = true
        this.errorLayout = true
      }
      // 変更フラグを削除する
      this.removeChangeFlags()
    },
    '$i18n.locale' () {
      // ページタイトル制御（言語切替時）
      this.pageTitle = this.getPageTitle(this.$router.history.current.name)
      // title要素を書き換える
      document.title = this.getTitleElementString(this.pageTitle)
      // 企業ロゴの表示フラグを変更する
      if (this.$router.history.current.name === this.getHomepage()) {
        this.visibleLogo = true
      } else {
        this.visibleLogo = false
      }
    },
    'getCart.item_list' (itemList) {
      // バッジ表示制御
      this.cartItemCount = this.calcQuantity(itemList, this.getCart.accounting_coupon)
    },
    'getCart.accounting_coupon' (coupon) {
      // バッジ表示制御
      this.cartItemCount = this.calcQuantity(this.getCart.item_list, coupon)
    },
    'updated' (flg) {
      if (flg) {
        // バッジ表示制御
        this.cartItemCount = this.calcQuantity(this.getCart.item_list, this.getCart.accounting_coupon)
      }
      this.updated = false
    },
    'getServerTime' (time) {
      // store.server_timeが更新されたらタイマーを更新する
      this.timerControl()
    },
    'getAuthority' (res) {
      this.checkDatepicker()
    },
    'menu' (flg) {
      // ハンバーガーメニュー展開時のスクロールを制限する
      this.preventBackgroundScrolling(flg)
    }
  },
  methods: {
    // カートボタンをクリックした時の遷移処理
    gotoCart: function (event) {
      // ハンバーガーメニューが展開されていたら閉じる
      if (this.menu) {
        this.menu = false
      }
      // カートのアイテム数、会計割引クーポンの合計が0の場合はクリックを無効にする
      if (this.calcCartItem() === 0) {
        return false
      }
      // ボタンが非活性状態の場合はクリックを無効にする
      if (this.getDisabledButton) {
        return false
      }
      sessionStorage.removeItem('changeReceiveMethod') // 受け取り変更フラグを倒す
      sessionStorage.removeItem('changeCartNumber') // 内容変更フラグを倒す
      this.$router.push({ name: 'Cart' }, () => {}, () => {})
    },
    // メニューのトグル処理
    toggleMenu: function () {
      if (this.getDisabledButton) {
        return false
      }
      this.menu = !this.menu
    },
    // ページ遷移
    transition: function (event, name) {
      // [ph0.1]表示するものがないのでクリックに対して反応しない
      if (name === 'PrivacyPolicy') return false

      // カートが0件の場合はクリックを無効にする
      if (name === 'Cart') {
        if (this.calcCartItem() === 0) {
          return false
        }
      }

      this.menu = false

      // 受け取り方法変更フラグを倒す
      sessionStorage.removeItem('changeReceiveMethod')
      sessionStorage.removeItem('changeCartNumber') // 内容変更フラグを倒す

      switch (name) {
        case 'Cart':
        case this.getHomepage():
          // NavigationDuplicatedエラーの表示を抑止する
          this.$router.push({ name }, () => {}, () => {})
          break
        default:
          this.$router.push({ name })
          break
      }
    },
    // アプリからのログイン
    appLogin: function () {
      // ホームページでないなら処理をしない
      if (this.$route.name !== this.getHomepage()) {
        return false
      }
      // codeパラメータがnull, undefined, 0文字である場合は処理をしない
      if (this.$route.query.code === null ||
        this.$route.query.code === undefined ||
        this.$route.query.code.length === 0) {
        return false
      }
      // 既にログインしている時は処理をしない
      if (sessionStorage.getItem('login') !== null) {
        return false
      }

      let _that = this
      // POSTパラメータ
      let params = {
        'onetime_token': this.$route.query.code,
        'language': 'ja'
      }
      this.callApi('Login',
        params
      )
      // this.axios.get('/static/stub/login.json')
        .then(function (res) {
          if (res.data.result) {
            // メールアドレスをencryptする
            const email = _that.CryptoJS.AES.encrypt(res.data.value.user_info.mail_address, process.env.VUE_APP_EMAIL_HASHKEY).toString()
            res.data.value.user_info.mail_address = email

            sessionStorage.setItem('login', JSON.stringify(res.data.value))
            _that.$store.dispatch('setAuthCompletedFromApp', true)
            sessionStorage.setItem('email', email)
            _that.$store.dispatch('setUserAuthority', get(res, 'data.value.authority', 1))
          } else {
            _that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch((error) => {
          _that.errorFromAxios(error)
        })
    },
    // 個数の計算
    calcQuantity: function (itemList, coupon) {
      let ret = 0
      if (itemList.length > 0) {
        for (let i = 0; i < itemList.length; i++) {
          ret += itemList[i].quantity
        }
      }
      if (coupon !== null) {
        ret += 1
      }
      return ret
    },
    // 変更フラグの削除
    removeChangeFlags: function () {
      switch (this.$route.name) {
        case 'ReceiveMethod':
          // NOTE changeReceiveMethodは強制削除しない
          sessionStorage.removeItem('changeCartNumber')
          break
        case 'SetMenuDetail':
          // NOTE changeCartNumberは強制削除しない
          sessionStorage.removeItem('changeReceiveMethod')
          break
        default:
          sessionStorage.removeItem('changeCartNumber')
          sessionStorage.removeItem('changeReceiveMethod')
          break
      }
    },
    // カート内の商品個数を計算して結果を返却する
    calcCartItem: function () {
      try {
        // 商品の個数
        let num = this.getCart.item_list.length
        // 会計割引クーポン
        if (this.getCart.accounting_coupon !== null) {
          num += 1
        }
        return num
      } catch (ex) {
        this.errorFromApp('ErrorMsg.ERR_999', ex)
      }
    },
    // Datepicker入力イベント
    input_open_at: function (d) {
      let openAtStr = null
      if (d !== null) {
        const inputDate = Moment(d)
        if (inputDate.isValid) {
          openAtStr = inputDate.format('YYYY-MM-DD')
        }
      }
      this.$store.dispatch('setOpenAt', openAtStr)
    },
    // 初期処理
    init: function () {
      // MFカード入力ページの復元用データをクリアする
      if (this.$route.name !== 'InputMFCardChargeComplete') {
        localStorage.removeItem('mfcard')
        localStorage.removeItem('lang')
        localStorage.removeItem('vuex')
        localStorage.removeItem('login')
      }
      // 注文受付処理中ページの復元用データをクリアする(SBPSリンク型用)
      if (this.$route.name !== 'OrderProcessing') {
        localStorage.removeItem('lang_link')
        localStorage.removeItem('vuex_link')
        localStorage.removeItem('login_link')
        localStorage.removeItem('email_link')
        localStorage.removeItem('linkPayMethod')
      }
      // サーバー時間を取得する
      this.initTime()
      // 変更フラグを削除する
      this.removeChangeFlags()
      // Datepicker初期設定
      this.initDatepicker()
      // for common-dialog
      window.commonAlert = this.commonAlert
      window.commonConfirm = this.commonConfirm
    },
    // Datepicker初期設定
    initDatepicker: function () {
      // datepicker当日ハイライト指定
      this.Datepickerparam.highlighted.dates.push(new Date())
      // 初期値設定
      if (this.$store.getters.openAt !== null) {
        this.Datepickerparam.initialDate = Moment(this.$store.getters.openAt).toDate()
      }
      // 特権ユーザチェック
      this.checkDatepicker()
    },
    // 特権ユーザチェック
    checkDatepicker: function () {
      this.Datepickerparam.display = this.$store.getters.userAuthority === 2
    },
    commonAlert: function (_options) {
      let options = {}
      if (isObject(_options)) {
        options = clone(_options)
      } else if (isString(_options)) {
        options.text = _options
      }
      options.buttons = 1
      return this._commonDialog(options)
    },
    commonConfirm: function (_options) {
      let options = {}
      if (isObject(_options)) {
        options = clone(_options)
      } else if (isString(_options)) {
        options.text = _options
      }
      options.buttons = 2
      return this._commonDialog(options)
    },
    _commonDialog: function (options) {
      if (this.dialogParam._textYes === '') {
        this.dialogParam._textYes = this.$i18n.t('Dialog.YesText')
      }
      if (this.dialogParam._textNo === '') {
        this.dialogParam._textNo = this.$i18n.t('Dialog.NoText')
      }
      if (this.dialogParam._textOk === '') {
        this.dialogParam._textOk = this.$i18n.t('Dialog.OkText')
      }

      this.dialogParam.text = replace(get(options, 'text', ''), /\n/g, '<BR />')
      this.dialogParam.buttons = toNumber(get(options, 'buttons', 1))
      this.dialogParam.textYes = get(options, 'textYes', '')
      this.dialogParam.textNo = get(options, 'textNo', '')
      this.dialogParam.textOk = get(options, 'textOk', '')
      if (this.dialogParam.text !== '') {
        this.dialogParam.pop = true
      }
      const self = this
      return new Promise(function (resolve) {
        self.dialogParam.resolve = resolve
      })
    },
    confirmAlert: function () {
      this.dialogParam.pop = false
      this.dialogParam.resolve(true)
    },
    rejectAlert: function () {
      this.dialogParam.pop = false
      this.dialogParam.resolve(false)
    },
    /** ↓↓↓時間制御機能 ここから */
    timerControl: function () {
      const that = this
      if (this.fkmoTimer !== null) {
        if (this.fkmoTimer['datetime'] !== null) {
          let serverTime = new Date(this.getServerTime.replace(/-/g, '/'))
          // タイマー管理時間とサーバー時間を比較し、更新されていたらタイマーを停止する
          if (serverTime >= this.fkmoTimer['datetime']) {
            clearInterval(this.fkmoTimer['timer'])
          } else {
            return false
          }
        }
      }

      if (this.getServerTime !== null) {
        // 初期化
        this.fkmoTimer = []

        // タイマーを設定
        const datetime = new Date(this.getServerTime.replace(/-/g, '/'))
        this.fkmoTimer['datetime'] = datetime
        this.fkmoTimer['timer'] = window.setInterval(function () {
          that.timerCountUp()
          that.isSales()
          that.isAcceptingMenu()
          that.$store.dispatch('setIsInitComplete', true)
        }, 1000)
      }
    },
    // タイムカウントアップ
    timerCountUp: function () {
      this.fkmoTimer['datetime'].setSeconds(this.fkmoTimer['datetime'].getSeconds() + 1)
    },
    isSales: function () {
      if (this.getSelectStore.store_cd) {
        this.setIsSales(this.fkmoTimer, this.getSelectStore)
      }
    },
    isAcceptingMenu: function () {
      if (this.getSelectStore.store_cd) {
        this.setIsAcceptingMenu(this.fkmoTimer, this.getSelectStore)
      }
    },
    /**
     * サーバー時間を取得してタイマーにセットする時間を初期化する
     * 1. サーバー時間取得APIよりサーバーの現在時刻を取得する
     * 2. 端末のローカル時間を取得する
     * 3. 1.と2.の差分を求める（dataに保持する）
     * 4. 2.と3.を加算して算出した時間を調整時間と定義。この時間をstore.server_timeにセットする
     */
    initTime: function () {
      const _that = this
      this.callApi('GetServerTime',
        {}
      )
        .then((res) => {
          if (res.data.result) {
            // ローカル端末との時差を求める
            const local = new Date() // 端末の時間
            const server = new Date(res.data.value.server_time.replace(/-/g, '/')) // サーバー時間
            _that.appTime.difference = server - local
            const adjustment = new Date(local.getTime() + _that.appTime.difference) // 調整時間
            // format(YYYY-MM-DD hh:mm:ss)
            const formatted = String(adjustment.getFullYear()).concat('-')
              .concat(String(adjustment.getMonth() + 1)).concat('-')
              .concat(String(adjustment.getDate())).concat(' ')
              .concat(String(adjustment.getHours())).concat(':')
              .concat(String(adjustment.getMinutes())).concat(':')
              .concat(String(adjustment.getSeconds()))

            // 既存のfkmoTimerを停止する
            if (_that.fkmoTimer !== null) {
              window.clearInterval(_that.fkmoTimer['timer'])
              _that.fkmoTimer = null
            }
            // 調整時間をサーバー時間としてセット
            _that.$store.dispatch('setServerTime', formatted)
            // 差分チェックをキックする
            _that.checkTimeDifferencial()
          }
        })
    },
    /**
     * 定期的に端末で保持している差分時間をチェックする
     * 1. store.server_timeを取得する。
     * 2. 端末の時間を取得する。
     * 3. 1.と2.の差分を取得し、更にdata.appTime.differenceと比較する。
     * 4. 3.の比較結果、1秒以上差分が生じている場合はinitTimeメソッドを実行する。
     */
    checkTimeDifferencial: function () {
      const _that = this
      // 既存タイマーを停止する
      if (this.appTime.checkTimer !== null) {
        window.clearInterval(this.appTime.checkTimer)
        this.appTime.checkTimer = null
      }
      let local
      let difference
      // タイマーを開始する
      this.appTime.checkTimer = setInterval(() => {
        local = new Date()
        // fkmoTimerの時間から時間差分を引き、実際にどれだけ時間に差分が出ているかを算出する（結果：ミリ秒）
        difference = Math.abs(_that.fkmoTimer['datetime'] - local) - Math.abs(_that.appTime.difference)
        // 5000ミリ秒以上差が出たらinitTimeを再実行する。
        if (Math.abs(difference) > 5000) {
          _that.initTime()
        }
      }, 600000) // 10分ごとにチェックをする
    }
    /** ↑↑↑時間制御機能 ここまで */
  },
  created () {
    // back-forward cache対策(for Safari browser)
    window.addEventListener('popstate', (event) => {
      // UA判定
      if (window.navigator.userAgent.toLowerCase().indexOf('msie') !== -1 &&
        window.navigator.userAgent.toLowerCase().indexOf('trident') !== -1) {
        // NOTE IE->何もしない
      } else if (window.navigator.userAgent.toLowerCase().indexOf('edge') !== -1) {
        // NOTE Edge->何もしない
      } else if (window.navigator.userAgent.toLowerCase().indexOf('chrome') !== -1) {
        // NOTE Chrome->何もしない
      } else if (window.navigator.userAgent.toLowerCase().indexOf('safari') !== -1) {
        // NOTE Safari->popstateしたらリロードを挟む
        window.location.reload()
      } else {
        // NOTE その他->何もしない
      }
    })
  },
  beforeMount () {
    // ページタイトル制御（load時）
    this.pageTitle = this.getPageTitle(this.$router.history.current.name)
    // バッジ表示制御
    this.cartItemCount = this.calcQuantity(this.getCart.item_list, this.getCart.accounting_coupon)
    // 企業ロゴの表示フラグを変更する
    if (this.$router.history.current.name === this.getHomepage()) {
      this.visibleLogo = true
    } else {
      this.visibleLogo = false
    }
    // 企業名を取得してmodelにセットする
    this.companyName.fk = this.getCompanyName('FK')
    this.companyName.wfk = this.getCompanyName('WFK')
    // アプリからのログイン処理
    this.appLogin()
    // 初期処理
    this.init()
    // 直遷移時のレイアウト変更対応（watchに引っかからないため）
    if (this.$router.currentRoute.name === 'ErrorPage') {
      this.visibleLogo = true
      this.errorLayout = true
    } else {
      this.errorLayout = false
    }
    // d払いチェック
    this.DPayEnabled = this.$store.getters.isDPayEnabled
  },
  mounted () {
    const self = this
    this.$nextTick(function () {
      // 特権ユーザチェック
      self.checkDatepicker()
      // d払いチェック
      self.DPayEnabled = this.$store.getters.isDPayEnabled
    })
  }
}
</script>

<style>
@import 'assets/css/reset.css';
@import 'assets/css/layout.css';
@import 'assets/css/common.css';
#open_at {
  width: 60%;
}
.vdp-datepicker__clear-button > span > i {
  font-size: 26px;
  color: #FFF;
}
#common-modal.enable {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue